// Port of api/fuel/app/classes/filter/search/games/filters/post/play/plays/users.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import { rangeActive } from 'offline/filter/core/search/unit'
import Helpers from 'offline/filter/core/helpers'

export default {
	name: 'post.play.plays.users',
	priority: 57,
	post: true,
	require: function(config, filter) {
		return config.ownerType !== F.OWNER_USER && config.resultType === F.RESULT_GAME && rangeActive(filter.play && filter.play.users, 0, 100)
	},
	run: function(config, filter, data, results) {
		if (!results.index.length || !results.concat || !results.concat.p || !results.concat.p.length) return results
		var rows = DB.query(
			'SELECT game_id AS g FROM play WHERE game_id IN(' + Util.in(results.index) + ') AND user_id IN(' + Util.in(data.users) + ') GROUP BY game_id HAVING COUNT(DISTINCT user_id) >= ' + filter.play.users.from + ' AND COUNT(DISTINCT user_id) <= ' + filter.play.users.to + ' AND play_id IN(' + Util.in(results.concat.p) + ')'
		)
		var newIndex = Util.pluck(rows, 'g').map(function(id) { return parseInt(id, 10) }).filter(Boolean)
		results.index = Helpers.preserve_sort(results.index, newIndex.map(function(id) { return { id: id } }), 'id').map(function(item) { return item.id })
		return results
	}
}
